export const CHAIN_ID_KEY = 'chainId';
export const CHAIN_NAME_KEY = 'chainName';
export const PERMISSIONS_KEY = 'permissions';
export const PLACE_ID_KEY = 'placeId';
export const CASHBACK_FACTOR = 'cashbackFactor';
export const USER_ID_KEY = 'userId';

export const PERMISSIONS = {
    ACCESS_RESGATE: 'access-resgate',
    REPRINT_COUPON: 'reprint-coupon',
    PASSWORD_LESS_REDEMPTIOM:'password-less-redemption',
    // Mesma permission usada pelo pontuax-admin para liberar a tela de cadastro
    // de cliente (`ClientCreate`) e o botão "Criar" da listagem de clientes.
    // O backend também a exige no scope do JWT em POST /customers.
    CREATE_CUSTOMER: 'create-customer',
}